"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.navZhHans = void 0;
/** 与 NavNode.msg 路径一致；中文与 Vue CloudPods 侧栏历史文案、React routerConfig 对齐 */
exports.navZhHans = {
    catalog: {
        ml: '机器学习',
        maasServiceNav: '模型服务',
        aiAppBuild: 'AI应用构建',
    },
    aiApp: {
        knowledgeBase: '知识库',
        appBuild: '应用构建',
        appMarket: '应用市场',
    },
    mlops: {
        overview: '概览',
        aiMarket: 'AI市场',
        computeMarket: '算力市场',
        trainAndInference: '训练 & 推理',
        containerInstance: '容器实例',
        trainTask: '训练任务',
        trainTemplate: '训练模版',
        inferenceService: '推理服务',
        aiAssets: 'AI资产',
        dataset: '数据集',
        modelManage: '模型管理',
        containerImage: '容器镜像',
        repository: '镜像仓库',
        diskStorage: '磁盘存储',
        resourceManage: '资源管理',
        dedicatedResource: '专属资源',
        resourceQuota: '资源配额',
        resourceMonitor: '资源监控',
        resourceAudit: '资源审计',
        systemSetting: '系统设置',
        resourceDashboard: '资源大盘',
        computeCluster: '计算集群',
        storageCluster: '存储集群',
    },
    maas: {
        modelSquareSection: '模型广场',
        modelSquare: '模型广场',
        experienceCenter: '体验中心',
        serviceManage: '服务管理',
        usageStatistics: '用量统计',
        servicePrice: '服务价格',
        apiKey: 'API Key',
        systemSetting: '系统设置',
        modelServiceSetting: '模型服务',
    },
    bill: {
        feeCenter: '费用中心',
        accountOverview: '账户总览',
        fundManage: '资金管理',
        transactionDetail: '收支明细',
        rechargeRemit: '充值汇款',
        transactionHistory: '充值历史',
        orderManage: '订单管理',
        myOrder: '我的订单',
        billManage: '账单管理',
        billOverview: '账单概览',
        billDetail: '账单详情',
        costBill: '成本账单',
        resourceUsage: '资源用量',
        invoiceManage: '发票管理',
        invoices: '发票',
        userRights: '用户权益',
        couponCenter: '代金券管理',
        adminManage: '后台管理',
        accountRecharge: '账户充值',
        adminOrderManage: '订单管理',
        adminProductManage: '产品管理',
        productPromotionManage: '产品促销',
        couponManage: '代金券',
        invoiceManageAdmin: '发票管理',
    },
};
